export enum GRID_FILTER_TYPE {
    VALUE = 'VALUE',
    RANGE = 'RANGE',
    PERCENT_RANGE = 'PERCENT_RANGE',
    DATES_RANGE = 'DATES_RANGE',
    MULTI_SELECTABLE_LIST = 'MULTI_SELECTABLE_LIST',
    SINGLE_SELECTABLE_LIST = 'SINGLE_SELECTABLE_LIST',
}
